import VolumeTiersRow from './elements/VolumenTiersRow';
import RulesPanel from '../../../../../common/rulesPanel/RulesPanel';
import EmptyState from '../../../../../common/emptyState/EmptyState';
import { Pill } from '@clockout-dev/design-elements';
import styles from '../../styles/feeStructureForm.module.scss';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

/**
 * Dumb sub-tab view. Receives the bundle from
 * `VolumeTiersPanelController.getViewProps()` — `orderedRules`,
 * `conflictIds`, `errorMessage`, the `onAdd` / `onRemove` / `onUpdate`
 * mutators owned by the parent FeeStructureController, and the local
 * `onCommitOrder` from the sub-controller.
 */
function VolumeTiersPanel({
    orderedRules = [],
    conflictIds = new Set(),
    errorMessage,
    onAdd,
    onRemove,
    onUpdate,
    onCommitOrder
}) {
    return (
        <div className={styles.panel}>
            <Pill
                classNames={{ root: styles.warningPill, text: styles.warningText }}
                text="If an amount falls out of the segmentation the fee will be derived from your Instant Advance Fee configuration"
            >
                <ExclamationTriangleIcon className={styles.warningIcon} />
            </Pill>
            <RulesPanel
                onAdd={onAdd}
                addLabel="Add a threshold setting row"
                errorMessage={errorMessage}
                emptyState={
                    <EmptyState
                        title="No volume thresholds yet"
                        description="Add a row to charge a different fee per advance amount range."
                    />
                }
                classNames={{ root: styles.volumenTierPanel }}
            >
                {orderedRules.map((rule) => (
                    <VolumeTiersRow
                        key={rule.id}
                        id={rule.id}
                        from={rule.fromAmount}
                        to={rule.toAmount}
                        fee={rule.fee}
                        commitOrder={onCommitOrder}
                        conflictIds={conflictIds}
                        onRemove={onRemove}
                        onUpdate={onUpdate}
                    />
                ))}
            </RulesPanel>
        </div>
    );
}

export default VolumeTiersPanel;
